module.exports = __webpack_public_path__ + "img/dollar.ffba11ca.png";